<ng-container [formGroup]="formGroup">

  <app-amount-slider-field
    [formControlName]="fieldName"
    [disableRequiredIdentifier]="disableRequiredIdentifier"
  ></app-amount-slider-field>

  <app-error-message
    [control]="control"
    [field]="fieldName"
    [label]="''"
  ></app-error-message>

</ng-container>
